const SET_ERRORS = (state, payload) => {
  state.errors = payload;
};

const CLEAR_ERRORS = state => {
  state.errors = {};
};

const SET_COMMON_ERRORS = (state, payload) => {
  state.commonErrors = payload;
};

const CLEAR_COMMON_ERRORS = state => {
  state.commonErrors = [];
};

export default {
  SET_ERRORS,
  CLEAR_ERRORS,
  SET_COMMON_ERRORS,
  CLEAR_COMMON_ERRORS
};
